<template>
    <div class="about">
        <menuBox :step="2"></menuBox>
        <div class="about-box">
            Terms of Service
        </div>
        <div class="content">
            <h2 style="text-align: center;">Reelbuzz User Agreement</h2><br><br>
            I. Introduction<br>

            Thank you for choosing Reelbuzz!<br>
            Reelbuzz is an online platform providing various mini-dramas and short videos. The service includes but is
            not limited to mobile applications, websites, related software and content provided therein (collectively
            referred to as "Reelbuzz" or "Service").<br>

            Contracting Entity<br>
            This Agreement ("Agreement" or "Terms") is a binding agreement between the individual or entity identified
            in your account ("you," "your," or "user") and Reelbuzz.<br>
            We reserve the right to periodically modify and/or amend these Terms by posting notice and/or through other
            reasonable means. We encourage you to review the revised terms regularly, and you must comply with these
            terms when using the service. Your continued use of our services indicates your acceptance of the revised
            terms. Any disputes between you and Reelbuzz shall be governed by the most recent terms. If you do not agree
            to the revised terms, you must stop using the service.<br>

            Age Requirement<br>
            Reelbuzz is not intended for children under 13 years of age ("children"). Children may not use our services
            for any purpose. Reelbuzz will never knowingly solicit or accept personal identity information or other
            content from users or visitors under the age of 13 known to Reelbuzz. If Reelbuzz discovers that a user
            under the age of 13 has created an account or that a user or visitor under the age of 13 has posted personal
            identity information or other content to the service, Reelbuzz will terminate the account and delete the
            information or other content.<br>

            Users between the ages of 13 and 18 ("teenagers") may not access or use the service unless (a) teenagers and
            their parents or legal guardians first agree to these terms of service; (b) teenagers, under the supervision
            and with the permission of their parents or legal guardians, use an account established by their parents or
            legal guardians. If you allow teenagers to use the service, you hereby represent that you and the teenagers
            agree to these terms of service. You further agree that you are fully responsible for any and all use of the
            service by your teenagers, whether such use is expressly authorized by you or not.<br>

            Acceptance of Terms of Service<br>
            These terms constitute a legally binding agreement between you and us. Please take the time to read them
            carefully. Generally, if you agree to abide by these terms, we will allow you to use our services. By
            accessing or using our services, you represent that (a) you are over 18 years of age, (b) you acknowledge
            that you have read, understood, and unconditionally accepted these terms, and agree to abide by them, and
            (c) if you are between 13 and 18 years of age, your legal guardian has reviewed and agreed to these terms of
            service. In addition to these terms, you also agree to abide by any supplemental policies and terms related
            to the service, as well as any other operational rules, policies, and procedures that may be posted on the
            service from time to time, each of which is incorporated herein by reference. For example, your access to
            and use of our services is also subject to our Privacy Policy, the terms of which can be found directly on
            our website or our applications, and are incorporated herein by reference.<br>
            If you do not understand or agree to these terms, please do not use these services. If you do not agree to
            these terms of service, you are not authorized to access, view, or otherwise use the services for any
            purpose, and you must immediately cease all such use. Use of the service under prohibition is void.<br>



            II. Your Account<br>

            1. You may use some of our services (including purchases or payments) without logging in. However, to access
            or use certain services, you will need to create an account with us. When you create an account, you agree
            to:<br>
            (a) Provide true, accurate, current, and complete information about yourself as prompted by the service.<br>
            (b) Maintain and promptly update such information to keep it true, accurate, current, and complete. If any
            information you provide is untrue, inaccurate, incomplete, or outdated, you will be deemed to have violated
            these terms, and we reserve the right to suspend or terminate your account and refuse any and all current or
            future use of the service by you.<br>

            2. You are responsible for maintaining the confidentiality of your account and password and restricting
            access to your computer, and you agree to be responsible for all activities that occur under your account or
            password. Unless otherwise expressly provided in this Agreement, you may not sell, trade, or otherwise
            transfer your account or any rights to another party, and you are solely responsible for all activities that
            occur under your password or account, whether or not you are aware of such activities.<br>

            3. You agree to immediately notify us of any unauthorized use of your username or password or any other
            breach of security. You also agree to ensure that you exit your account at the end of each session.<br>

            4. We also allow you to register and log in to Reelbuzz using login features provided by third-party
            platforms such as Facebook and Google. You agree to comply with the terms and conditions applicable to your
            use of such features on the relevant third-party platforms (in addition to these terms), and acknowledge
            that Reelbuzz is not responsible for the content of such terms and conditions.<br>

            5. If you no longer wish to use our services and wish to delete your account, please send an email to
            services@reelbuzztv.com We will provide further assistance and guide you through the entire process. Once
            you choose to delete your account, you will not be able to reactivate your account or retrieve any content
            or information you have added (including free and paid content).<br>

            6. Reelbuzz reserves the right, at its sole discretion, to suspend or terminate your account, delete or
            remove your content (defined below), and/or refuse any and all current or future use of the service (whether
            or not we believe you have failed to comply with these terms, our Privacy Policy, content guidelines, any
            other policies, and/or any provisions of applicable laws or regulations), with or without notice. If your
            account remains inactive for an extended period, and you do not use your account again after receiving such
            inactive notification sent to the email address associated with your account or through inbox messages, we
            may also terminate or suspend your account.<br>

            7. If your account is terminated, access to your username, password, and any associated information or
            content with your account may be terminated. As we do not guarantee the permanent availability of your
            content, you should make and maintain backups of any content that you value at your own expense.<br>

            8. Your account name and any other identifiers you adopt in Reelbuzz remain our property, and we may
            disable, reclaim, and reuse such information once your account is terminated or deactivated by you or us for
            any reason.<br>




            III. User Code of Conduct<br>

            1. You should access and use Reelbuzz services in compliance with this agreement and applicable laws and
            regulations. You may only use Reelbuzz services for personal non-commercial purposes, and commercial use
            requires our written permission. Furthermore, you agree not to engage in or utilize Reelbuzz services for
            the following activities (nor provide assistance and support to others for such activities). Otherwise, you
            shall be liable for all consequences resulting from this, and if it causes any loss and/or adverse effects
            to us, you shall fully compensate and mitigate the adverse effects.<br>
            2. Harming minors and/or other individuals in any way;<br>
            3. Engaging in activities that infringe upon the legitimate rights and interests of Reelbuzz or others, or
            engaging in illegal or criminal activities, including providing assistance for the aforementioned
            activities;<br>
            4. Without prior express written permission from Reelbuzz, obtaining services, content, or information from
            the Reelbuzz platform in any way (including but not limited to automated programs, bots, spiders, and any
            other software) and for any reason, either personally or through others;<br>
            5. Circumventing, removing, altering, obstructing, damaging, or otherwise disrupting the security measures
            used by Reelbuzz to protect its services;<br>
            6. Displaying any or all of Reelbuzz's service content in whole or in part in any public venue, whether for
            a fee or for free, without explicit authorization from Reelbuzz (except where your actions do not constitute
            infringement);<br>
            7. Using Reelbuzz services through improper means or in a manner contrary to the principles of honesty and
            creditworthiness (such as exploiting loopholes in rules, exploiting system vulnerabilities, abusing
            membership status, engaging in black market activities, speculation, etc.) that contravene the original
            intent of Reelbuzz's service provision;<br>
            8. Falsifying content (including titles) in any way to make it appear as though it was transmitted by
            us;<br>
            9. Uploading, releasing, transmitting by email, or otherwise transmitting software viruses, political
            propaganda, commercial solicitations (such as advertising letters, promotional materials), chain letters,
            bulk mail, or other forms of "spam," content that infringes upon any person's patents, trademarks,
            copyrights, trade secrets, or other proprietary rights, and/or unauthorized content (such as internal
            materials, confidential information).<br>



            IV. Content Purchases<br>

            Some services and content on Reelbuzz are provided to you free of charge, while other services and content
            require payment to access. You are responsible for paying all such payments and related obligations under
            this agreement.<br>

            Paid Viewing<br>
            You may be required from time to time to pay us appropriate fees and meet applicable terms related to the
            services, such as obtaining a license to use certain parts of the service.<br>
            You acknowledge that, according to the policies of the Apple Store and Google Play, we reserve the right to
            change our terms of service in any way, at any time, in whole or in part, or adjust the pricing and
            availability of our services or any of their components. At our sole discretion and time. If there are price
            adjustments or promotional activities, whether permanent or temporary, we do not offer price protection or
            refunds.<br>
            Payments shall be made through Google Payments and any other payment methods for automatic, periodic, or
            subscription fees that we may provide to you from time to time. If we do so, you agree (subject to
            applicable laws and regulations):<br>
            (a) Such purchases or payments are usually made in advance by you;<br>
            (b) You authorize us to store information about your chosen payment method (such as credit card information)
            on our systems and bill your chosen payment method during the relevant period;<br>
            (c) If any payment made through your chosen payment method is rejected, refused, or unpaid for any reason,
            we may not provide or suspend the provision of the relevant content, products, or services until the payment
            is correctly processed; you shall be responsible for any fees, costs, expenses, or other amounts incurred by
            us due to such rejection, refusal, or non-payment (and we may automatically charge you such amounts).<br>

            You agree to comply with any applicable legal agreements governing your use, including but not limited to
            the Google Payments Terms of Service. In addition to any other relevant terms of this agreement, all such
            payments made by you must comply with the terms and conditions of the relevant payment services (whether
            provided by third parties or us). We are not responsible for any transactions processed by third parties or
            any payments made to third parties, whether related to the services or not. All purchases may be subject to
            taxes and other charges, including but not limited to foreign exchange fees or location-based price
            differences (such as exchange rates), and you are solely responsible for all fees and taxes associated with
            any services.<br>

            You agree that any amounts you pay us for the use of any services are final and non-refundable unless
            otherwise specified in this agreement. Otherwise, in no event shall we be required to refund any amounts
            paid by you to us in connection with any services (whether used or unused).<br>

            Please note that you are responsible for all third-party charges associated with your use of the service or
            arising from your use of the service (including any charges imposed by your internet and telecommunications
            service providers).<br>

            If you believe we have charged you in error, you must notify us within 30 days of the date of the charge by
            contacting us at services@reelbuzztv.com, and after this time, any erroneous charges will not be
            refunded.<br>


            Apple Auto-Renewable Subscription Description<br>

            Payment: After the user confirms the purchase and payment, it will be credited to the iTunes account;
            Canceling Renewal: If you need to cancel the renewal, the user can manually turn off the automatic renewal
            function in the iTunes/Apple ID settings management within 24 hours before the current subscription period
            expires, and no fees will be deducted after cancellation;<br>
            Renewal: The Apple iTunes account will be charged within 24 hours before the expiration. After the deduction
            is successful, the subscription period will be extended by one subscription period.<br>
            V. Intellectual Property Rights<br>

            For content protected by intellectual property rights that we own or have authorized to use, and that are
            provided on Reelbuzz services or obtained through Reelbuzz services (including but not limited to software,
            interfaces, interactive elements, logos, trademarks, logos, graphics, text, audio, sound, videos, portraits,
            images, technologies, materials, collectively referred to as "Reelbuzz Content" in this section), we reserve
            all rights to Reelbuzz Content.<br>
            You may not copy, distribute, rent, exhibit, perform, display, broadcast, transmit, film, adapt, translate,
            compile, create derivative works, or offer for sale Reelbuzz content and services without our authorization.
            Regarding the software (and its technology) in Reelbuzz services.<br>
            You may need to download our software during your use of Reelbuzz services, and we only grant you a
            revocable, limited, non-transferable, and non-exclusive license for such software. You may only download and
            use the software for non-commercial purposes of accessing/using the service.<br>
            To improve user experience, ensure product and service security and consistency, we may update the software.
            We recommend that you update the software to the latest version.<br>
            You may not copy, modify, release, sell, or rent any part of our services or the software contained therein,
            nor engage in reverse engineering, decompiling, disassembling, or any other similar acts attempting to
            extract the source code of such software.<br>



            VI. Advertising, Third Parties<br>

            1. You acknowledge and agree that we reserve the right to display commercial advertisements (including ad
            links) or any other type of commercial information in various ways while providing Reelbuzz services,
            provided that it complies with applicable laws and regulations (including but not limited to placing
            advertisements anywhere on the Reelbuzz platform).<br>
            2. Subject to applicable laws and regulations, we have the right to independently decide the form, duration,
            location, and content of advertising placement without any third-party intervention.<br>
            3. You acknowledge and agree that we may transmit product promotions or other relevant commercial
            information to you through obtained email, text messages, or other means, and we will provide you with an
            unsubscribe method.<br>
            4. Our services may provide links to other international internet websites or resources. We will require
            advertisers to fulfill relevant obligations in accordance with applicable laws and regulations, but you
            acknowledge and agree that these advertisers and advertising content are not controlled by us. You should
            exercise caution in judging the authenticity and reliability of advertising information. You are solely
            responsible for any actions or disputes with advertisers or sponsors, and we do not assume any additional
            liability, but will provide necessary assistance as required by law.<br>



            VII. Protection of User Personal Information<br>

            Our "Privacy Policy" explains how we collect, process, and protect your personal information and your
            control over personal information when using our services. Please read it carefully.<br>



            VIII. General Provisions<br>

            Force Majeure: We shall not be liable for any damages or losses caused by force majeure. For the purposes of
            this agreement, force majeure includes but is not limited to acts of God, changes in laws or regulations,
            government orders, specific reasons caused by the nature of internet services, such as failures caused by
            domestic and/or foreign basic telecommunications operators, computers, or the internet, technical defects,
            internet coverage limitations, computer viruses, hacker attacks, and other unforeseeable, unavoidable, and
            insurmountable circumstances permitted by laws and regulations.<br>



            VIII. Disclaimer, Liability Limitation, and Indemnification<br>

            1. Any provision in this Agreement does not affect any statutory rights that you, as a user, are entitled to
            and cannot be changed or waived by contract. All disclaimers and liability limitation clauses contained in
            this Agreement shall apply only to the extent permitted by applicable laws and regulations.<br>
            2. You acknowledge and agree that, except as otherwise provided in this Agreement or as required by
            applicable laws and regulations, the Reelbuzz service is provided on an "as is" basis, and we make no
            express or implied representations or warranties regarding the services (including technology and
            information) provided, including but not limited to the content in the service, specific features of the
            service, its reliability, availability, and whether it meets your needs. However, we commit to continuously
            improving the quality and level of service to provide users with better service. Except as otherwise
            provided by applicable laws and regulations, we shall only be liable to the extent permitted by law for any
            indirect, incidental, consequential, or punitive damages and/or losses, including but not limited to loss of
            profits, business reputation, business opportunities, data, or other tangible or intangible losses arising
            from the service. We also do not assume any responsibility for any defamation, criminal activity, or other
            illegal actions by any third party, nor do we compensate for any losses caused thereby.<br>
            3. We only assume the direct liability explicitly provided in this Agreement. Except as otherwise provided
            by applicable laws and regulations or this Agreement, in no event shall our total liability under this
            Agreement exceed the total service fees we charged for providing services to you.<br>
            4. You agree that if any litigation or dispute arises against us or any third party using the Reelbuzz
            service due to your actions described below, when we make a request, you agree to defend us or the
            aforementioned third party and compensate us or the aforementioned third party for any losses suffered:
            (1) Your violation of any terms of this Agreement;<br>
            (2) Your infringement or suspected infringement of any intellectual property rights or other legal rights;
            (3) Anyone claims that your actions have harmed the rights of third parties.<br>
            You shall make every effort to cooperate with us in defending against such claims. We reserve the right to
            independently defend and control any matters arising from claims made by you.<br>

            5. You acknowledge and agree that we have an obligation to disclose the identity information of any
            individual suspected of releasing content in violation of this Agreement to relevant judicial enforcement
            agencies, administrative authorities, and courts. In the case of non-confidential investigations, we have no
            obligation to keep such information confidential, and we shall not be liable for any disclosure, provided
            that we may notify you of such investigations as necessary.<br>

            6. You acknowledge and agree that you waive your right to claim against us for any losses incurred due to
            any actions taken by us during the investigation or any actions taken by us or any law enforcement agency
            regarding the investigation results.<br>



            IX. Changes and Termination of Service<br>

            1. To the extent permitted by applicable laws and regulations, we have the right to temporarily or
            permanently change or terminate the Reelbuzz service (or any part thereof) based on the development of our
            business. We shall not be liable for breach of contract due to changes or termination of the Reelbuzz
            service (or any part thereof). If changes or termination of the Reelbuzz service (or any part thereof)
            result in loss of your legal rights, upon your application, we will provide you with appropriate
            compensation according to the confirmed actual losses.<br>
            2. To the maximum extent permitted by applicable laws and/or regulations, this Agreement, and other platform
            rules, we have the right, based on legitimate reasons, to suspend or terminate your use of the account, log
            out or revoke your account, terminate your use of the Reelbuzz service, or change, delete, or transfer the
            content stored, released on our platform by you.
            3. The termination, cancellation, or expiration of this Agreement shall not affect the continued validity of
            the rights and obligations already accrued by both parties.<br>



            X. Contact Information<br>

            1. All notices to you under this Agreement will be communicated through webpage announcements, emails,
            mobile text messages, or other reasonable means, and such notices shall be deemed to have been delivered to
            you on the date of transmission. If multiple notification methods are used simultaneously, the earliest
            transmission time among the aforementioned methods shall prevail.<br>
            2. If you have any questions regarding this Agreement or matters related to the use of Reelbuzz services
            (including inquiries, complaints, etc.), you can contact us through the following methods:
            (1) Send an email to: services@reelbuzztv.com<br>
            (2) Other contact methods provided by Reelbuzz. We will respond to your opinions and suggestions as soon as
            possible after receiving them.<br>

        </div>
        <footerBox :step="2"></footerBox>
    </div>
</template>
<script>
import footerBox from "@/components/footer";
import menuBox from "@/components/menu";
export default {
    name: "App",
    components: {
        menuBox,
        footerBox,
    },
    data() {
        return {
            val: ''
        };
    },
    mounted() { },
    methods: {
        step() {
            this.$router.push({ path: "Services" });
        },
    },
};
</script>
<style lang="less" scoped>
.about-box {
    position: relative;
    top: -100px;
    background-image: url(../assets/Privacy.png);
    width: 100%;
    height: 300px;
    background-size: 100% 100%;
    padding: 130px 360px 0 360px;
    font-family: Poppins, Poppins;
    font-weight: bold;
    font-size: 52px;
    color: #FFFFFF;
    line-height: 61px;
    text-align: center;
    box-sizing: border-box;
}

.content {
    padding: 0 360px 200px;
    color: #4E4E4E;
    font-style: 20px;
}
</style>